import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function EmpPostAJobPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: "",
        subject: "",
        body: "",
        status: "",
        lang: ""
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.post(`${API_URL}/admin/create-emailTemplate`, formData);
            if (response.data.status === 201) {
                alert("Emails added successfully!");
                navigate("/employer/emails");
                // window.location.reload();
            } else {
                alert("Failed to add subscription.");
            }
        } catch (error) {
            console.error("Error adding subscription", error);
            alert("Something went wrong!");
        }
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Emails Add</h2>
                <div className="breadcrumbs">
                    <a href="#">Home</a><a href="#">Dashboard</a><span>Emails Add Form</span>
                </div>
            </div>

            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" /> Emails Add</h4>
                </div>
                <div className="panel-body wt-panel-body p-a20 m-b30 ">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Title</label>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        name="title"
                                        placeholder="Enter Email Title"
                                        value={formData.title}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Subject</label>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        name="subject"
                                        placeholder="Enter Email Subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Status</label>
                                    <div className="ls-inputicon-box">
                                        <select
                                            className="form-control"
                                            name="status"
                                            rows={5}
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <i className="fs-input-icon fa fa-info-circle" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Language Type</label>
                                    <div className="ls-inputicon-box">
                                        <select
                                            className="form-control"
                                            name="lang"
                                            rows={5}
                                            value={formData.lang}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Lang</option>
                                            <option value="english">English</option>
                                            <option value="français">Français</option>
                                        </select>
                                        <i className="fs-input-icon fa fa-language" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-12 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Body</label>
                                    <textarea
                                        className="form-control"
                                        rows={10}
                                        name="body"
                                        placeholder="Enter Description"
                                        value={formData.body}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <Alert variant="danger">
                                <span>
                                    ❗ {t("Placeholders Instructions :")}
                                    <br />
                                    {'{{JOB_TITLE}}'} - {t("Enter the job title you are applying for.")}
                                    <br />
                                    {'{{INTERVIEWER_NAME}}'} - {t("Enter the name of the interviewer.")}
                                    <br />
                                    {'{{COMPANY_NAME}}'} - {t("Enter the company’s name.")}
                                    <br />
                                    {'{{SKILL_SET}}'} - {t("Enter the key skills relevant to the job.")}
                                    <br />
                                    {'{{USER_FIRSTNAME}} {{USER_LASTNAME}}'} - {t("Your first and last name will auto-fill.")}
                                    <br /><br />
                                    {t("Note: These fields are placeholders. They will be replaced with actual values automatically when the email is sent via automation.")}
                                </span>
                            </Alert>
                            <div className="col-lg-12 col-md-12">
                                <div className="text-left">
                                    <button type="submit" className="site-button m-r5">Add Emails</button>
                                    {/* <button type="button" className="site-button outline-primary">Save Draft</button> */}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default EmpPostAJobPage;










